var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaixa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1017,
    height: 236,
    viewBox: "0 0 1017 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.916 78.1561L284.595 145.265H321.02L311.035 77.883L310.916 78.1561ZM171.477 232.213L279.447 4.77846H361.08L406.601 232.213H334.937L329.655 201.899H260.129L244.134 232.213H171.477ZM440.533 232.213L471.81 4.77846H544.022L512.76 232.213H440.533ZM920.825 77.883L894.4 145.265H930.81L920.825 77.883ZM781.267 232.213L889.252 4.77846H970.871L1016.41 232.213H944.728L939.46 201.899H869.919L853.925 232.213H781.267Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0070AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M621.621 125.864H712.112L774.116 230.921H683.61L621.621 125.864Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0070AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M631.028 109.727H724.562L805.795 5.10987H712.261L631.028 109.727Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F6822A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M537.509 231.557H631.027L712.26 125.664H618.727L537.509 231.557Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F6822A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M571.23 3.83483H658.517L718.326 109.727H631.024L571.23 3.83483Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0070AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.612 12.913L166.668 79.8092C140.052 42.2399 78.3624 68.1664 73.5181 114.965C67.3622 174.362 126.734 188.206 159.042 153.232L152.084 220.28C142.441 225.122 133.011 228.887 123.703 231.422C114.446 233.972 105.169 235.323 95.9637 235.52C84.3907 235.779 73.9053 234.534 64.4585 231.817C55.0118 229.145 46.4626 224.895 38.8987 219.157C24.3108 208.243 13.7631 194.369 7.26595 177.489C0.768783 160.549 -1.36925 141.438 0.844448 120.08C2.62935 102.912 6.855 87.2623 13.5896 73.0694C20.2663 58.8918 29.5157 45.9891 41.2934 34.3009C52.4272 23.1591 64.552 14.7499 77.6725 9.04237C90.7425 3.38042 105.005 0.359604 120.423 0.02565C129.632 -0.171677 138.668 0.769516 147.437 2.94019C156.253 5.09567 164.947 8.46544 173.612 12.913Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0070AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaixa);
export default __webpack_public_path__ + "static/media/caixa.d7cd99964ee281a41af0dd711b0d8b63.svg";
export { ForwardRef as ReactComponent };